<template>
	<section>
		<div class="djcontainer">
			<BaseHeading
				type="h5"
				class="mt-10 mb-0 md:mb-7 relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
				id="job-anchor-top"
			>
				{{ $t("job.info") }}
			</BaseHeading>
		</div>
		<div
			class="grid grid-cols-1 md:grid-cols-3 justify-self-center gap-x-[40px] max-w-[345px] sm:max-w-[680px] md:max-w-[1040px] lg:max-w-[1420px] w-full"
		>
			<div
				class="block md:hidden mt-10"
				v-if="
					jobData &&
					Object.keys(jobData).length > 0 &&
					jobData.boxes &&
					Object.keys(jobData.boxes).length > 0 &&
					langs &&
					locale &&
					locale.length > 0
				"
			>
				<DjBoxRte
					class="dj-box-job-about block md:hidden mb-0"
					:title="$t('job.about')"
					:copy="jobData?.boxes?.job_job_description?.data?.description?.[locale] || ''"
					without-margin
				></DjBoxRte>
			</div>
			<div class="md:col-span-2 mt-10 md:mt-5">
				<div
					class="md:flex justify-between items-center border border-dj-grey-light/50 rounded-big bg-white mb-5 md:mb-10"
				>
					<DjBoxSalary
						v-if="jobData?.jobSalary && jobData?.boxes?.job_salary?.wizard_step?.name"
						class="border-none md:mb-0"
						id="jobProfileSalaryBox"
						:title="jobData.boxes.job_salary.wizard_step.name?.[locale] || ''"
						:salary="jobData?.jobSalary"
						:langs="{
							salary: $t('job.salary'),
							salaryRange: $t('job.salaryRange'),
							notSpecified: $t('job.notSpecified'),
							bonus: $t('job.bonus'),
							amountIn: jobData?.jobSalary.amountIn == 'gross' ? $t('job.gross') : $t('job.net'),
							perMonth: $t('job.perMonth'),
							perHour: $t('job.perHour'),
						}"
					/>
					<NuxtLink v-if="region === 'HU' || region === 'RO'" :to="salaryCalculatorUrl" target="_blank">
						<DjCard
							class="bg-white cursor-pointer w-[280px] mx-auto mb-7 md:w-[320px] md:mr-7 md:mb-0"
							hover
						>
							<div class="flex items-center px-4 py-3">
								<div
									class="rounded-full w-[35px] h-[35px] flex items-center justify-center mr-5 bg-lime-100"
								>
									<BaseIcon
										icon="ic:outline-account-balance-wallet"
										class="text-base"
										color="#78BE32"
									/>
								</div>
								<span>{{ $t("berkalkulator.shortTitle") }}</span>
								<BaseButton
									square
									type="tertiary"
									class="text-dj-gray group-hover:bg-dj-blue group-hover:text-white ml-auto"
								>
									<span class="material-icons-outlined">arrow_forward</span>
								</BaseButton>
							</div>
						</DjCard>
					</NuxtLink>
				</div>
			</div>
			<div
				class="md:col-span-1 mt-10 md:mt-5"
				v-if="
					jobData &&
					Object.keys(jobData).length > 0 &&
					jobData.boxes &&
					Object.keys(jobData.boxes).length > 0 &&
					langs &&
					locale &&
					locale.length > 0
				"
			>
				<DjBox
					class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10"
					v-if="
						langs.howToApply &&
						jobData.boxes.job_how_to_apply &&
						jobData.boxes.job_how_to_apply.wizard_step &&
						jobData.boxes.job_how_to_apply.wizard_step.name &&
						jobData.boxes.job_how_to_apply.data
					"
				>
					<h3 class="text-lg md:text-xl font-medium mb-4">
						{{ jobData.boxes.job_how_to_apply.wizard_step.name[locale] }}
					</h3>
					<div v-for="(type, index) in jobData.boxes.job_how_to_apply.data" :key="index">
						<div class="flex items-start" v-if="index === 'languages'">
							<span
								class="block ml-2 mr-5 mt-[6px] min-w-[12px] w-3 min-h-[12px] h-3 rounded-full bg-dj-blue"
							></span>
							<span class="text-dj-gray mb-4">
								{{ $t("applicationLanguageTitle") }}:
								<br />
								<span v-for="(t, i) in type" :key="i">
									<span v-if="t == 'hu'">{{ $t("hungarian") }},</span>
									<span v-if="t == 'ro'">{{ $t("romanian") }},</span>
									<span v-if="t == 'en'">{{ $t("english") }},</span>
								</span>
							</span>
						</div>
					</div>
					<div v-for="(type, index) in jobData.boxes.job_how_to_apply.data" :key="index">
						<template v-if="index === 'options'">
							<template v-for="(t, i) in type" :key="i">
								<div class="flex items-start" v-if="t['hu'] != 'Self-branding profil'">
									<span
										class="block ml-2 mr-5 mt-[6px] min-w-[12px] w-3 min-h-[12px] h-3 rounded-full bg-dj-blue"
									></span>
									<span class="text-dj-gray mb-4">
										{{ t[locale] }}
										<br />
									</span>
								</div>
							</template>
						</template>
					</div>
					<template v-if="isAuth && readySbpLangs > 0">
						<div v-for="(type, index) in jobData.boxes.job_how_to_apply.data" :key="index">
							<template v-if="index === 'options'">
								<template v-for="(t, i) in type" :key="i">
									<div class="flex items-start" v-if="t['hu'] == 'Self-branding profil'">
										<span
											class="block ml-2 mr-5 mt-[6px] min-w-[12px] w-3 min-h-[12px] h-3 rounded-full bg-dj-blue"
										></span>
										<span class="text-dj-gray mb-4">
											{{ t[locale] }}
											<br />
										</span>
									</div>
								</template>
							</template>
						</div>
					</template>
				</DjBox>
			</div>
		</div>
		<div class="masonrycontainer block columns-1 sm:columns-1 md:hidden"></div>
		<div
			v-if="
				jobData &&
				Object.keys(jobData).length > 0 &&
				jobData.boxes &&
				Object.keys(jobData.boxes).length > 0 &&
				langs &&
				locale &&
				locale.length > 0
			"
			class="masonrycontainer"
		>
			<DjBoxBenefits
				v-if="
					benefits.length > 0 &&
					jobData.boxes.job_other_benefits &&
					jobData.boxes.job_other_benefits.wizard_step &&
					jobData.boxes.job_other_benefits.wizard_step.name &&
					jobData.boxes.job_other_benefits.data
				"
				:title="jobData.boxes.job_other_benefits.wizard_step.name[locale]"
				:data="benefits"
				:locale="locale"
				:langs="langs.benefitsBox"
			/>

			<DjBoxWorkSchedule
				v-if="
					langs.workScheduleBox &&
					jobData.boxes.job_work_schedule &&
					jobData.boxes.job_work_schedule.wizard_step &&
					jobData.boxes.job_work_schedule.wizard_step.name &&
					jobData.boxes.job_work_schedule.data
				"
				:title="jobData.boxes.job_work_schedule.wizard_step.name[locale]"
				:data="jobData.boxes.job_work_schedule.data"
				:langs="langs.workScheduleBox"
				:locale="locale"
			/>

			<DjBoxTasks
				v-if="
					jobData.boxes.job_tasks &&
					jobData.boxes.job_tasks.wizard_step &&
					jobData.boxes.job_tasks.wizard_step.name &&
					jobData.boxes.job_tasks.data
				"
				:title="jobData.boxes.job_tasks.wizard_step.name[locale]"
				:locale="locale"
				:data="jobData.boxes.job_tasks.data[locale]"
			/>

			<DjBoxTechnology
				v-if="
					jobData.tags &&
					jobData.tags.technology &&
					jobData.tags.technology.data &&
					jobData.tags.technology.data.length > 0 &&
					jobData.boxes.job_technologies &&
					jobData.boxes.job_technologies.wizard_step &&
					jobData.boxes.job_technologies.wizard_step.name
				"
				:title="jobData.boxes.job_technologies.wizard_step.name[locale]"
				:locale="locale"
				:data="jobData.tags.technology.data"
			/>

			<DjBoxSkills
				v-if="
					jobData.boxes.job_skills &&
					jobData.boxes.job_skills.wizard_step &&
					jobData.boxes.job_skills.wizard_step.name
				"
				:title="jobData.boxes.job_skills.wizard_step.name[locale]"
				:locale="locale"
				:data="jobData.boxes.job_skills.data"
			/>

			<DjBoxEducations
				v-if="jobData.boxes.job_languages && jobData.educations"
				:education-title="$t('job.educationTitle')"
				:educations="jobData.educations || []"
				:language-title="jobData.boxes.job_languages.wizard_step.name[locale]"
				:languages="jobData.boxes.job_languages.data.languages"
				:locale="locale"
				:relation="jobData.boxes.job_languages.data.relation"
				:langs="langs.educationsBox"
			/>

			<BoxesShare />

			<DjBoxTags
				v-if="
					jobData.boxes.job_soft_skills &&
					jobData.boxes.job_soft_skills.wizard_step &&
					jobData.boxes.job_soft_skills.wizard_step.name &&
					jobData.tags &&
					jobData.tags.soft_skill &&
					jobData.tags.soft_skill.data &&
					jobData.tags.soft_skill.data.length > 0
				"
				:title="jobData.boxes.job_soft_skills.wizard_step.name[locale]"
				:tags="getSoftskillTags()"
			/>

			<DjBoxJobTeamInfo
				v-if="
					jobData.boxes.job_team_info &&
					jobData.boxes.job_team_info.wizard_step &&
					jobData.boxes.job_team_info.wizard_step.name &&
					jobData.boxes.job_team_info.data &&
					jobData.boxes.job_team_info.data.length > 0
				"
				:title="jobData.boxes.job_team_info.wizard_step.name[locale]"
				:ageTitle="$t('job.teamInfo.teamAgeRange')"
				:ageText="`${jobData.boxes.job_team_info.data[0].min_age} - ${jobData.boxes.job_team_info.data[0].max_age}`"
				:sizeTitle="$t('job.teamInfo.teamSize')"
				:sizeText="jobData.boxes.job_team_info.data[0].team_size[locale]"
			/>
			<DjBoxPhotosWithLabel
				v-if="
					jobData.boxes.job_team_images &&
					jobData.boxes.job_team_images.wizard_step &&
					jobData.boxes.job_team_images.wizard_step.name
				"
				:title="jobData.boxes.job_team_images.wizard_step.name[locale]"
				:data="getTeamPhotos()"
				class="dj-box-photos-with-label"
				bold-label
				borderless
			/>

			<DjBoxPhotosWithLabel
				v-if="
					jobData.boxes.job_co_workers &&
					jobData.boxes.job_co_workers.wizard_step &&
					jobData.boxes.job_co_workers.wizard_step.name &&
					jobData.boxes.job_co_workers.data &&
					jobData.boxes.job_co_workers.data[locale] &&
					jobData.boxes.job_co_workers.data[locale][0] &&
					jobData.boxes.job_co_workers.data[locale][0].employees.length > 0
				"
				:title="jobData.boxes.job_co_workers.wizard_step.name[locale]"
				:data="getCoworkerPhotos()"
				class="dj-box-photos-with-label"
				bold-label
				borderless
			/>

			<DjBoxRte
				v-if="
					jobData.boxes.job_how_we_work &&
					jobData.boxes.job_how_we_work.wizard_step &&
					jobData.boxes.job_how_we_work.wizard_step.name &&
					jobData.boxes.job_how_we_work.data &&
					jobData.boxes.job_how_we_work.data.description
				"
				:title="jobData.boxes.job_how_we_work.wizard_step.name[locale]"
				:copy="jobData.boxes.job_how_we_work.data.description[locale]"
			/>

			<DjBoxRte
				v-if="
					jobData.boxes.job_what_you_will_learn &&
					jobData.boxes.job_what_you_will_learn.wizard_step &&
					jobData.boxes.job_what_you_will_learn.wizard_step.name &&
					jobData.boxes.job_what_you_will_learn.data &&
					jobData.boxes.job_what_you_will_learn.data.description
				"
				data-type="job_what_you_will_learn"
				:title="jobData.boxes.job_what_you_will_learn.wizard_step.name[locale]"
				:copy="jobData.boxes.job_what_you_will_learn.data.description[locale]"
			/>

			<DjBoxRte
				v-if="
					jobData.boxes.job_ideal_candidate &&
					jobData.boxes.job_ideal_candidate.wizard_step &&
					jobData.boxes.job_ideal_candidate.wizard_step.name &&
					jobData.boxes.job_ideal_candidate.data &&
					jobData.boxes.job_ideal_candidate.data.description
				"
				:title="jobData.boxes.job_ideal_candidate.wizard_step.name[locale]"
				:copy="jobData.boxes.job_ideal_candidate.data.description[locale]"
			/>

			<DjBoxRte
				v-if="
					jobData.boxes.job_job_description?.wizard_step?.name &&
					jobData.boxes.job_job_description?.data?.starting_date?.[locale]
				"
				:title="$t('job.card.youCanStartAt')"
				:copy="jobData.boxes.job_job_description.data.starting_date[locale]"
			/>

			<DjBoxRte
				v-if="
					jobData.boxes.job_good_to_know &&
					jobData.boxes.job_good_to_know.wizard_step &&
					jobData.boxes.job_good_to_know.wizard_step.name &&
					jobData.boxes.job_good_to_know.data &&
					jobData.boxes.job_good_to_know.data.description
				"
				:title="jobData.boxes.job_good_to_know.wizard_step.name[locale]"
				:copy="jobData.boxes.job_good_to_know.data.description[locale]"
			/>

			<DjBoxJobList
				v-if="
					jobData.boxes.job_do_not_apply &&
					jobData.boxes.job_do_not_apply.wizard_step &&
					jobData.boxes.job_do_not_apply.wizard_step.name &&
					jobData.boxes.job_do_not_apply.data &&
					jobData.boxes.job_do_not_apply.data[locale] &&
					jobData.boxes.job_do_not_apply.data[locale].length > 0
				"
				:title="jobData.boxes.job_do_not_apply.wizard_step.name[locale]"
				:data="getDoNotApplyList()"
			/>

			<DjBoxPhotosWithLabel
				v-if="jobData.badges && jobData.badges.length > 0"
				:title="$t('job.box.badges')"
				:data="getBadges()"
				bold-label
				borderless
			/>

			<template v-if="jobData.boxes.additional && Object.keys(jobData.boxes.additional.data).length != 0">
				<template v-for="(item, index) in jobData.boxes.additional.data" :key="index">
					<template v-if="item.type === 'image'" class="dj-box-photos-with-label">
						<DjBoxPhoto
							:title="item.data.boxtitle[locale] != '' ? item.data.boxtitle[locale] : ''"
							:photoId="item.data.cloudinary"
							:photo-alt="
								item.data.boxtitle[locale] != '' && typeof item.data.boxtitle[locale] != 'object'
									? item.data.boxtitle[locale]
									: 'box photo'
							"
						/>
					</template>
					<template v-if="item.type === 'text'">
						<DjBoxRte :title="item.data.boxtitle[locale]" :copy="item.data.boxtext[locale]" />
					</template>
					<template v-if="item.type === 'quote' && item.data && item.data.authortitle">
						<DjBoxQuote
							:text="item.data.text[locale]"
							:authorPhotoId="item.data.cloudinary"
							:author="item.data.author[locale]"
							:authorTitle="item.data.authortitle[locale]"
						/>
					</template>
					<template v-if="item.type === 'article'">
						<DjBoxArticle
							:boxTitle="item.data.boxtitle[locale]"
							:url="item.data.url ? item.data.url[locale] : ''"
							:urlTitle="item.data.url_title ? item.data.url_title[locale] : ''"
							:apiUrl="globalConfig.API"
						/>
					</template>
					<template
						v-if="
							item.type === 'covid-19' ||
							item.type === 'new-normal' ||
							item.type === 'digital-solutions' ||
							item.type === 'szmd-box-2025'
						"
						class="dj-box-photos-with-label"
					>
						<DjBoxPhotoWithRte
							:title="
								item.type === 'covid-19'
									? $t('company.box.freeCovidBox')
									: item.type === 'new-normal'
									? $t('company.box.freeNewNormalBox')
									: item.type === 'digital-solutions'
									? $t('company.box.freeDigitalSolutions')
									: item.type === 'szmd-box-2025'
									? $t('company.box.freeSzmdBox2025')
									: ''
							"
							:photoId="item.data[0].cloudinary"
							:text="item.data[0].description[locale]"
						/>
					</template>
					<template v-if="item.type === 'video'">
						<DjBoxVideo
							:title="item.data.boxtitle[locale]"
							:videoType="item.data.type"
							:videoId="item.data.video_id"
							:videoUrl="item.data.video"
						/>
					</template>
				</template>
			</template>
		</div>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, onMounted, computed, watch } from "vue";
import type { JobItem } from "@@/composables/useJob";
import { ConfigRepository } from "~~/repositories/ConfigRepository";

export default defineComponent({
	name: "JobProfileBoxes",
	props: {
		jobData: {
			type: Object as PropType<JobItem>,
			default: null,
		},
	},
	setup(props) {
		const benefits = ref([]);
		const region = computed(() => {
			return useRegion.getCurrentRegion().code;
		});
		const { locale } = useI18n();
		const salaryCalculatorUrl = ref("");

		const isAuth = useState("isAuth");
		const readySbpLangs = ref<number[]>([]);

		const langs = useLangs.jobProfilePage;

		watch(isAuth, (val: boolean) => {
			val == true && getAccountData();
		});

		onMounted(() => {
			getBenefits();
			isAuth.value == true && getAccountData();
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
		});

		watch(locale, () => {
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
		});

		function getSoftskillTags() {
			if (props.jobData?.tags?.soft_skill?.data) {
				return props.jobData.tags.soft_skill.data.map((tag) => tag.name[locale.value]);
			} else {
				return [];
			}
		}

		function getTeamPhotos() {
			if (
				props.jobData &&
				props.jobData.boxes &&
				props.jobData.boxes.job_team_images &&
				props.jobData.boxes.job_team_images.data &&
				props.jobData.boxes.job_team_images.data[locale.value] &&
				props.jobData.boxes.job_team_images.data[locale.value][0]
			) {
				return props.jobData.boxes.job_team_images.data[locale.value][0].images.map((photo) => {
					return {
						url: photo.cloudinary,
						...(photo.caption && { label: photo.caption }),
					};
				});
			} else {
				return [];
			}
		}

		function getCoworkerPhotos() {
			if (
				props.jobData &&
				props.jobData.boxes &&
				props.jobData.boxes.job_co_workers &&
				props.jobData.boxes.job_co_workers.data
			) {
				return props.jobData.boxes.job_co_workers.data[locale.value][0].employees.map((coworker) => {
					return {
						url: coworker.avatar ? coworker.avatar.cloudinary : "",
						label: coworker.name,
					};
				});
			} else {
				return [];
			}
		}

		function getDoNotApplyList() {
			if (
				props.jobData &&
				props.jobData.boxes &&
				props.jobData.boxes.job_do_not_apply &&
				props.jobData.boxes.job_do_not_apply.data &&
				props.jobData.boxes.job_do_not_apply.data[locale.value] &&
				props.jobData.boxes.job_do_not_apply.data[locale.value].length > 0
			) {
				return props.jobData.boxes.job_do_not_apply.data[locale.value].map((item) => {
					return {
						title: item,
					};
				});
			} else {
				return [];
			}
		}

		function getBenefits() {
			const neededTags = [
				"benefits_travel",
				"benefits_catering",
				"benefits_training",
				"benefits_assets",
				"benefits_wellbeing",
			];
			neededTags.forEach((tag) => {
				if (props.jobData && props.jobData.tags && props.jobData.tags[tag]) {
					benefits.value.push({
						langKey: tag.split("_")[1],
						data: props.jobData.tags[tag].data,
					});
				}
			});
			if (
				props.jobData &&
				props.jobData.boxes &&
				props.jobData.boxes.job_other_benefits &&
				props.jobData.boxes.job_other_benefits.data &&
				props.jobData.boxes.job_other_benefits.data.other
			) {
				benefits.value.push({
					langKey: "other",
					data: [{ name: { ...props.jobData.boxes.job_other_benefits.data.other } }],
				});
			}
		}

		function getBadges() {
			if (props.jobData && props.jobData.badges && props.jobData.badges.length > 0) {
				return props.jobData.badges.map((badge) => {
					return {
						url: badge.image.cloudinary,
						label: badge.name[locale.value],
					};
				});
			} else {
				return [];
			}
		}

		function getAccountData() {
			const userData = useAuth.getUser();
			readySbpLangs.value = userData.ready_sbp_langs.length;
		}

		return {
			locale,
			langs,
			readySbpLangs,
			isAuth,
			benefits,
			getSoftskillTags,
			getTeamPhotos,
			getCoworkerPhotos,
			getDoNotApplyList,
			getBadges,
			region,
			salaryCalculatorUrl,
		};
	},
	mounted() {
		// TODO - Temporary solution until it is rewritten to VueGallery

		/*! Image Lightbox Script
		 * Copyright: Deo Kumar - Fineshop Design
		 * License: MIT
		 */
		function createPopupImageGallery(options: { selectors: never; ignoreClass: never; classes: never }) {
			function getType(e) {
				return Object.prototype.toString
					.call(e)
					.replace(/(?:^\[object\s(.*?)\]$)/, "$1")
					.toLowerCase();
			}
			const images = Array.prototype.filter.call(
				getType(options.selectors) === "string"
					? document.querySelectorAll(options.selectors)
					: getType(options.selectors) === "array"
					? document.querySelectorAll(options.selectors.join(","))
					: [],
				function (image) {
					return (
						image.tagName === "IMG" &&
						(getType(options.ignoreClass) === "string" && options.ignoreClass
							? !image.classList.contains(options.ignoreClass)
							: true)
					);
				}
			);
			if (images.length === 0) {
				return;
			}
			const lightBox = document.createElement("div");
			lightBox.className = options.classes.lightboxWrapper;
			lightBox.addEventListener("click", function () {
				lightBox.classList.remove("active");
			});
			lightBox.addEventListener("transitionend", function (event) {
				if (
					event.propertyName === "opacity" &&
					getComputedStyle(lightBox).getPropertyValue("opacity") === "0" &&
					!lightBox.classList.contains("active")
				) {
					lightBox.parentNode.removeChild(lightBox);
				}
			});
			images.forEach(function (image) {
				const imageContainer = document.createElement("div");
				imageContainer.className = options.classes.imageWrapper;
				image.parentNode.insertBefore(imageContainer, image);
				const aChild = imageContainer.appendChild(image);
				aChild.src = aChild.src.replace(/\/c_scale.+\//gi, "/");
				imageContainer.addEventListener("click", function (event) {
					event.preventDefault();
					lightBox.innerHTML = image.outerHTML;
					document.body.appendChild(lightBox);
					setTimeout(function () {
						lightBox.classList.add("active");
					}, 40);
				});
			});
		}

		createPopupImageGallery({
			selectors: ".dj-box-photos-with-label img",
			ignoreClass: "noLb",
			classes: {
				imageWrapper: "lbImg",
				lightboxWrapper: "zmImg",
			},
		});
	},
});
</script>
<style lang="css">
/*! Image Lightbox CSS
 * Copyright: Deo Kumar - Fineshop Design
 * License: MIT
 */
.lbImg {
	position: relative;
}
.lbImg::before {
	content: "";
	position: absolute;
	top: 10px;
	right: 5px;
	width: 30px;
	height: 30px;
	display: flex;
	margin: 0 5px;
	background: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23363637' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3'/></svg>")
		center / 14px no-repeat;
	background-color: rgba(0, 0, 0, 0.2);
	border-radius: 50%;
	z-index: 2;
	opacity: 0;
	transition: all 0.2s ease;
	cursor: pointer;
}
.lbImg:hover::before {
	opacity: 1;
}
.lbImg img {
	cursor: zoom-in;
}
.zmImg {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.75);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;
	-webkit-backdrop-filter: saturate(180%) blur(15px);
	backdrop-filter: saturate(180%) blur(15px);
	opacity: 0;
	visibility: hidden;
	transition: all 0.4s ease;
}
.zmImg.active {
	opacity: 1;
	visibility: visible;
}
.zmImg a,
.zmImg a:hover {
	opacity: 1;
}
.zmImg img {
	display: block;
	max-width: 92%;
	max-height: 92%;
	width: auto;
	margin: auto;
	border-radius: 10px;
	box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.05);
	transform: scale(0.4);
	transition: all 0.4s ease;
	transition-property: transform;
}
.zmImg.active img {
	transform: scale(1);
	cursor: zoom-out;
}
.zmImg img.full {
	left: auto;
	right: auto;
	border-radius: 10px;
	width: auto;
}
.zmImg::after {
	content: "\2715";
	line-height: 16px;
	font-size: 14px;
	color: #fffdfc;
	background: #482dff;
	position: fixed;
	bottom: -20px;
	right: -20px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 45px;
	height: 45px;
	border-radius: 50%;
	opacity: 0;
	visibility: hidden;
	transition: all 0.4s ease;
}
.zmImg.active::after {
	bottom: 20px;
	right: 20px;
	opacity: 1;
	visibility: visible;
	cursor: pointer;
}
</style>
